import { useState } from "react";
import type { MergedAccountView } from "@sales-ops-amplify/shared";
import { LeadEditorForm, LeadList } from "@/components/companies/lead-panel";

export function CompanyPeopleTab({
  merged,
  accountId,
  isMutable,
}: {
  merged: MergedAccountView;
  accountId: string;
  isMutable: boolean;
}) {
  const [showContactForm, setShowContactForm] = useState(false);
  const people = merged.people ?? [];

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between gap-2">
        <p className="text-sm text-muted-foreground">
          {people.length} contact{people.length === 1 ? "" : "s"}
        </p>
        {isMutable ? (
          <button
            type="button"
            onClick={() => setShowContactForm((v) => !v)}
            className="text-xs font-medium text-brand hover:underline"
          >
            {showContactForm ? "Cancel" : "+ Add person"}
          </button>
        ) : null}
      </div>

      {isMutable && showContactForm ? (
        <LeadEditorForm
          accountId={accountId}
          onCreated={() => setShowContactForm(false)}
        />
      ) : null}

      <LeadList
        leads={people.map((c) => ({
          id: c.id,
          name: c.name,
          email: c.email,
          phone: c.phone,
          mobilePhone: c.mobilePhone,
          linkedinUrl: c.linkedinUrl,
          role: c.role,
          title: c.title,
          seniority: c.seniority,
          departments: c.departments,
          lifecycleStage: c.lifecycleStage,
        }))}
        emptyMessage={
          isMutable
            ? "No people at this company yet."
            : "Save this company to manage people on your copy."
        }
      />
    </div>
  );
}
